import * as React from "react"

import { useIntl } from "react-intl"
import { DataTableBody } from "@walmart-web/livingdesign-components"

import { resolveMonthName } from "helpers/temporal"
import { capitalize } from "helpers/text"
import { BadgeProps } from "components/Transactional/SelloutReport/Table/Badge"
import SelloutTableRow from "components/Transactional/SelloutReport/ReportsTable/BodyTableRow"
import {
	TITLE_TABLE_TRANSLATION_ID,
	TABLE_HEADER,
} from "components/Transactional/SelloutReport/constants"
import Table, {
	HeaderTable,
} from "components/Transactional/SelloutReport/Table"
import { ReportMapEntry } from "components/Transactional/SelloutReport/reports.mapper"

export type ReportType = "basic" | "extended"
interface ReportsTableProps {
	data: ReportMapEntry[]
	setMessage: any
	isFetching: boolean
}

const ReportsTable: React.FC<ReportsTableProps> = ({
	data,
	setMessage,
	isFetching,
}) => {
	const intl = useIntl()
	const [disableDownload, setDisableDownload] = React.useState(false)
	const [isOpen, setIsOpen] = React.useState(0)
	const getDateTranslation = (date: string): string => {
		const [month, year] = date.split("-")
		const translatedDate = resolveMonthName(
			{ year: Number(year), month: Number(month) },
			intl
		)
		return capitalize(translatedDate) as string
	}

	const getReportTypeCellTranslation = (reportType: ReportType): BadgeProps => {
		if (reportType === "extended") {
			return {
				text: intl.formatMessage({
					id:
						"phronesis.sellout_report.application.reporting_sellout.table.reportType.extended",
				}),
				color: "green",
			}
		}

		return {
			text: intl.formatMessage({
				id:
					"phronesis.sellout_report.application.reporting_sellout.table.reportType.basic",
			}),
			color: "blue",
		}
	}

	if (data.length === 0 && !isFetching) {
		return null
	}

	return (
		<>
			<Table
				isFetching={isFetching}
				titleTranslationId={TITLE_TABLE_TRANSLATION_ID}
			>
				<HeaderTable headerColumns={TABLE_HEADER} />
				<DataTableBody>
					{data.map(({ label, reportType, items }, index) => (
						<SelloutTableRow
							index={index}
							key={label}
							date={getDateTranslation(label)}
							filename={label}
							reports={items}
							reportTypeProps={getReportTypeCellTranslation(reportType)}
							setMessage={setMessage}
							disableDownload={disableDownload}
							setDisableDownload={setDisableDownload}
							isOpen={isOpen}
							setIsOpen={setIsOpen}
						/>
					))}
				</DataTableBody>
			</Table>
		</>
	)
}

export default ReportsTable
